import { Capacitor } from '@capacitor/core'

function shouldSkipServiceWorker() {
  try {
    if (Capacitor.isNativePlatform()) return true
  } catch {
    /* ignore */
  }
  const h = typeof location !== 'undefined' ? String(location.hostname || '') : ''
  if (h === 'localhost' || h === '127.0.0.1' || h === '::1') return true
  if (h.endsWith('.androidplatform.net')) return true
  return false
}

/**
 * PWA service worker only for browser deployments. Native shell: unregister any old SW.
 */
export function setupServiceWorker() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return
  const clearExisting = () =>
    navigator.serviceWorker.getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .catch(() => {})

  if (!import.meta.env.PROD) {
    void clearExisting()
    return
  }
  if (shouldSkipServiceWorker()) {
    void clearExisting()
    return
  }
  const base = String(import.meta.env.BASE_URL || '/').replace(/\/+$/, '')
  const swUrl = base ? `${base}/sw.js` : '/sw.js'
  void navigator.serviceWorker.register(swUrl).then((reg) => {
    void reg.update().catch(() => {})
  }).catch(() => {})
}
